module.exports={
	"Form": "SampleStatusCreateManifest",
	"Scope": "SampleStatus-Create",
	"Descriptors":
	{
		"SampleStatusDetails.Name":
		{
			"Name": "Name",
			"Hash": "SampleStatus-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "SampleStatus-Create-Identity",
				"Group": "SampleStatus-Create-Identity"
			}
		},
		"SampleStatusDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "SampleStatus-Create-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Description":
		{
			"Name": "Description",
			"Hash": "SampleStatus-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Category":
		{
			"Name": "Category",
			"Hash": "SampleStatus-Create-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		},
		"SampleStatusDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "SampleStatus-Create-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "SampleStatus-Create-Details",
				"Group": "SampleStatus-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "SampleStatus-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "SampleStatus-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "SampleStatus-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "SampleStatus-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
